import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import helpersNumber from "../../../../../helpers/numbers";
import httpService from "../../../../../services/httpServices/httpServices";

export default function All() {
  const [allNotificationDesktop, setAllNotificationDesktop] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (roles.length == 0) {
      return;
    }
    getAllNotificationDesktop();
  }, [roles]);

  const getRoles = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let roles = await sendRequestGetRoles();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!roles) {
      return;
    }
    setRoles(roles);
  };

  const sendRequestGetRoles = async () => {
    const headersRequest = getHeaderForRequest();
    let roles;
    try {
      roles = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return roles.data.data;
  };

  const getAllNotificationDesktop = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allNotificationDesktop = await sendRequestGetAllNotificationDesktop();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allNotificationDesktop) {
      return;
    }
    setAllNotificationDesktop(allNotificationDesktop);
  };

  const sendRequestGetAllNotificationDesktop = async () => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/notification-dashboard/manage",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTableNotificationDesktop = () => {
    return (
      <div className="table-responsive pt-2">
        <table className="table table-hilite tbl-td-white-space m-0">
          <thead>
            <tr>
              <td>#</td>
              <td>شماره</td>
              <td>نقش</td>
              <td>تاریخ شروع</td>
              <td>آخرین بروزرسانی</td>
              <td>فعال</td>
              <td>عملیات</td>
            </tr>
          </thead>
          <tbody>
            {allNotificationDesktop.map((notificationDesktop, index) => {
              const notificationDesktopRole = roles.filter(
                (role) => notificationDesktop.not_role_user_id == role.rol_id
              );
              if (notificationDesktopRole.length < 1) {
                return;
              }
              return (
                <tr>
                  <td>{index + 1}</td>
                  <td>{notificationDesktop.not_id}</td>
                  <td>{notificationDesktopRole[0].rol_persian_name}</td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        notificationDesktop.not_created_at
                      ) +
                        " " +
                        notificationDesktop.not_created_at.split(" ")[1]
                    )}{" "}
                  </td>
                  <td>
                    {helpersNumber.toPersianNum(
                      helpersTime.convertGregorianToJalali(
                        notificationDesktop.not_updated_at
                      ) +
                        " " +
                        notificationDesktop.not_updated_at.split(" ")[1]
                    )}{" "}
                  </td>
                  <td>
                    {notificationDesktop.not_active ? (
                      <span className="badge badge-success">فعال</span>
                    ) : (
                      <span className="badge badge-danger">غیرفعال</span>
                    )}
                  </td>
                  <td>
                    <Link
                      className="btn btn-success"
                      to={`/user/notification-dashboard/edit/${notificationDesktop.not_id}`}
                    >
                      <i className="fa fa-edit"></i>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar activeItem="all-notification-dashboard" openItem="users" />

      <div className="content-wrapper">
        <TitleBar title="اطلاع رسانی های داشبورد" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <Link
                className="btn btn-success"
                to="/user/notification-dashboard/add"
              >
                <div>
                  <span className="pl-2">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>
                    <span>اضافه کردن </span>
                  </span>
                </div>
              </Link>
              {allNotificationDesktop.length > 0 ? (
                generateTableNotificationDesktop()
              ) : (
                <div className="alert alert-info">
                  هیچ اطلاع رسانی های داشبورد وجود ندارد.
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
